
// Import React for creating the BlogsPage component
import React from "react";
// Import CSS files for styling
import "../css/BlogsPage.css";
import "../css/App.css";
// Import reusable components and images
import Hero from "./components/Hero";
import HeroIamge from "../assets/images/photo-fence-two-people-walking-fenced-lawn-towards-old-building.jpg";
import BlogImage from "../assets/images/photo-fence-two-people-walking-fenced-lawn-towards-old-building.jpg";
import Button from "./components/Button";



// Array of previous blog entries (placeholder data)
const previousBlogs = Array(9).fill({
  title: "Blog Title",
  preview:
    "Preview Text. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  image: BlogImage,
  link: "https://www.google.com/?zx=1771409292849&no_sw_cr=1",
});


// BlogsPage component displays the main blog section and a grid of previous blogs
function BlogsPage() {
  return (
    <div className="blogs-page">
      {/* Hero section with background image and title */}
      <Hero
        title="BLOGS"
        subtitle=""
        backgroundImage={HeroIamge}
        titleAlign="center"
        subtitleAlign="center"
      />
      {/* Featured blog section */}
      <section
        className="service-section protection-section"
        id="protection-insurance"
      >
        <div className="service-image-wrapper">
          <img src={BlogImage} alt="Blogs" className="service-image" />
        </div>
        <div className="service-content dark-bg">
          <h2 className="service-heading white-text">Blog Title</h2>
          <p className="service-description white-text">
            Preview Text...Lorem ipsum dolor sit amet, consectetur adipiscing
            elit, sed do eiusmod tempor incididunt ut labore et dolore magna
            aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
            laboris nisi ut aliquip ex ea commodo consequat.  
          </p>
          {/* Uncomment to add more blog details or call-to-action button */}
        </div>
      </section>
      {/* Previous blogs grid section */}
      <div className="previous-blogs-section">
        <h2>BLOGS</h2>
        <h2 className="ContactUs">Previous Blogs</h2>
        <div className="previous-blogs-grid">
          {previousBlogs.map((blog, idx) => (
            <div className="service-card blog-card" key={idx}>
              <img src={blog.image} alt="Commercial Financial advice" />
              <div className="card-content">
                <p className="card-text">
                  Structured financial solutions for commercial portfolios.
                </p>
                {/* Button to open the blog link in a new tab */}
                <Button
                  text="Read More"
                  variant="card"
                  onClick={() => {
                    window.open(blog.link, "_blank");
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// Export the BlogsPage component as default
export default BlogsPage;
